import { render, staticRenderFns } from "./alocacao-total.vue?vue&type=template&id=0f9c9f45&scoped=true&"
import script from "./alocacao-total.vue?vue&type=script&lang=js&"
export * from "./alocacao-total.vue?vue&type=script&lang=js&"
import style0 from "./alocacao-total.vue?vue&type=style&index=0&id=0f9c9f45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c9f45",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9c9f45')) {
      api.createRecord('0f9c9f45', component.options)
    } else {
      api.reload('0f9c9f45', component.options)
    }
    module.hot.accept("./alocacao-total.vue?vue&type=template&id=0f9c9f45&scoped=true&", function () {
      api.rerender('0f9c9f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/alocacao-total.vue"
export default component.exports